import { render } from "./QuestDialog2.vue?vue&type=template&id=30228c55"
import script from "./QuestDialog2.vue?vue&type=script&lang=js"
export * from "./QuestDialog2.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/modals/questDialogs/QuestDialog2.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30228c55"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30228c55', __exports__)) {
    api.reload('30228c55', __exports__)
  }
  
  module.hot.accept("./QuestDialog2.vue?vue&type=template&id=30228c55", () => {
    api.rerender('30228c55', render)
  })

}


export default __exports__